export const SET_SETTING = "SET_SETTING";

export function setSetting(setting: any) {
	return {
		type: SET_SETTING,
		setting,
	};
}



// WEBPACK FOOTER //
// ../shared/store/settings/actions.js